import { render, staticRenderFns } from "./menudetails.vue?vue&type=template&id=69752b25&scoped=true"
import script from "./menudetails.vue?vue&type=script&lang=js"
export * from "./menudetails.vue?vue&type=script&lang=js"
import style0 from "./menudetails.vue?vue&type=style&index=0&id=69752b25&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69752b25",
  null
  
)

export default component.exports